(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["notification-form"] && !Shopify.designMode) return;
  try {
    jQuery('#notify-me').click(function() {
  jQuery('#notify-me-wrapper').fadeIn();           
  return false;
});
  jQuery(function(){
var $cf = jQuery('#sold-out form');
$cf.submit(function (e) {
      e.preventDefault();
      console.log(jQuery('input[name="challenge"]', $cf).val());
      if(jQuery('input[name="challenge"]', $cf).val() !== "true") {
        jQuery.ajax({
          type: $cf.attr('method'),
          url: $cf.attr('action'),
          data: $cf.serialize(),
          success: function (data) {
            //$cf.before('<p class="message">' + {{ 'general.newsletter_form.footer_success_text' | t | json }} + '</p>');
            jQuery('.accent-text',$cf).show();
            jQuery('#notify-me-wrapper').fadeOut();  
          },
          error: function(data) {
            console.log(data);
          	jQuery('input[name="challenge"]', $cf).val('true');
            jQuery('.error-text').show();
          	$cf.submit();
          }
        });
        
      }
});
  });
  } catch(e) { console.error(e); }
})();

})();
